import { JobEtabDetailModel, IJobEtabDetail } from "@core/models";

export const etablissementDetails = new JobEtabDetailModel({
  [IJobEtabDetail.name]: "Chez Franklin",
  [IJobEtabDetail.category]: "Brasserie Chic",
  [IJobEtabDetail.description]:
    "A Paris, le chef vous accueille tous les jours de 9h a 19h sauf le Dimanche. Nous vous proposons une cuisine exotique dans un cadre agréable et chaleureux.",
  [IJobEtabDetail.city]: "Paris",
  [IJobEtabDetail.postalCode]: "75003",
  [IJobEtabDetail.picture]: "https://picsum.photos/id/1060/1400/600",
});
